module.exports = __webpack_public_path__ + "img/Sin título-1-10.1931bce4.svg";